// extracted by mini-css-extract-plugin
export default {"view":"Params_view__PCao0","title":"Params_title__65cbg","label":"Params_label__CwPvF","input":"Params_input__no6Da","submit":"Params_submit__zTpn9"};